/* eslint-disable react/require-default-props */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import styles from './header.module.scss';

const SectionHeader = ({ icon, translationID, defaultTitle, values, centered, children, subtitle }) => {
  let headerStyles;
  if (centered) {
    headerStyles = `${styles.header} ${styles.center}`;
  } else {
    headerStyles = `${styles.header}`;
  }

  return (
    <div className={headerStyles}>
      <div className={styles.title}>
        <img src={icon} alt="Icon" />
        <div className={styles.titleTextWrapper}>
          <h1><FormattedMessage id={translationID} defaultMessage={defaultTitle} values={values} /></h1>
          {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        </div>
      </div>
      {children}
    </div>
  );
};

SectionHeader.defaultProps = {
  centered: false,
  children: []
};

SectionHeader.propTypes = {
  icon: PropTypes.string,
  translationID: PropTypes.string.isRequired,
  defaultTitle: PropTypes.string,
  centered: PropTypes.bool,
  children: PropTypes.node,
  subtitle: PropTypes.string
};

export default SectionHeader;
